import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Option } from '../../models';

@Component({
  selector: 'partnerhub-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonGroupComponent),
      multi: true,
    },
  ],
})
export class RadioButtonGroupComponent implements OnInit, OnDestroy, ControlValueAccessor {
  public get _horizontal(): boolean {
    if (this.horizontal === '' || this.horizontal) {
      return true;
    }
    return false;
  }

  @Input('dataKey')
  set DataKey(dataKey: string) {
    this.dataKey = dataKey === null ? dataKey : 'id';
  }

  @Input('optionLabel')
  set OptionLabel(optionLabel: string) {
    this.optionLabel = optionLabel === null ? optionLabel : 'name';
  }

  @Input('selectId')
  set SelectId(selectId: string) {
    this.selectId = selectId === null ? selectId : 'id';
  }

  private readonly complete$ = new Subject();

  public dataKey: string;

  public formControl = new FormControl();

  @Input() public groupName = '';

  @Input() public horizontal: boolean | string = false;

  public optionLabel: string;

  @Input() public options: Option[] = [];

  @Input() public returnAsObject;

  @Input('returnAsObject')
  set ReturnAsObject(returnAsObject: boolean) {
    this.returnAsObject = returnAsObject || returnAsObject === undefined ? true : false;
  }

  public selectId: string;

  // TODO: Disabled Options

  constructor() { }

  public ngOnDestroy(): void {
    this.complete$.next(true);

    this.complete$.complete();
  }

  public ngOnInit(): void {
    this.formControl.valueChanges.pipe().subscribe(() => {
      if (!this.formControl.value) {
        this.onChange(this.formControl.value);
      } else if (this.dataKey && this.options) {
        const value = this.options.find((option) => option[this.dataKey] === this.formControl.value);

        // TODO: Refactor this
        if (value) {
          if (this.returnAsObject) {
            this.onChange(value);
          } else {
            if (!this.returnAsObject && this.selectId) {
              // when we receive value as object
              this.onChange(this.selectId ? value[this.selectId] : value);
            } else if (this.dataKey) {
              // When we receive value as number & want to return it as number
              this.onChange(value[this.dataKey]);
            }
          }
        } else {
          this.onChange(value);
        }
      } else {
        this.onChange(this.formControl.value);
      }
    });
  }

  public onChange = (_: string | Option) => { };

  public onTouch = () => { };

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  public writeValue(value: string): void {
    if (value) {
      this.formControl.setValue(this.selectId ? value[this.selectId] : value);
    }

    this.onChange(this.formControl.value);
  }
}
